import withRoot from '../../withRoot';
import React, {useState, useEffect, Fragment} from 'react';
import {Table} from 'rsuite';
import TextField from "@material-ui/core/TextField/TextField";
import {gql, useLazyQuery} from "@apollo/client";
import {makeStyles} from "@material-ui/core/styles";
import Loading from "../../Loading";
import SearchIcon from "@material-ui/icons/Search";

const {Column, HeaderCell, Cell, Pagination} = Table;

const GET_EMISIONES = gql`
    query MyQuery {
      Otros_Emisiones(where: {Estado: {_neq: "Cancel"}}, order_by: {idCotizacion: desc}) {
        AfinidadInfo {
          Nombre
        }
        Estado
        emision_clientes {
          Cliente {
            dni
            apellido
            nombre
          }
        }
        NumeroReferencia
        Premium
        idEmision
        ProductoInfo {
          Nombre
        }
      }
    }
`;

const useStyles = makeStyles(theme => ({
    table: {
        marginTop: theme.spacing(3),
        backgroundColor: "#fff",
        borderRadius: "20px",
        boxShadow: "5px 10px 18px #888888",
        padding: "30px",
        position: "relative"
    },
    alertField: {
        '& label.Mui-focused': {
            color: "#BB0D66",
        },
    },
    centerVertically: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: "center",
    },
    endHorizontally: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: "flex-end",
        alignItems: "center",
    },
}))

const NameCell = ({rowData, dataKey, ...props}) => {
    switch (dataKey) {
        case 'AfinidadNombre':
            return (
                <Cell {...props}>
                    {rowData.AfinidadInfo[0].Nombre}
                </Cell>
            );
        case 'ClienteNombre':
            return (
                <Cell {...props}>
                    {rowData.emision_clientes[0].Cliente.nombre + " " + rowData.emision_clientes[0].Cliente.apellido}
                </Cell>
            );
        case 'DNI':
            return (
                <Cell {...props}>
                    {rowData.emision_clientes[0].Cliente.dni}
                </Cell>
            );
        case 'ProductoInfo':
            return (
                <Cell {...props}>
                    {rowData.ProductoInfo.Nombre}
                </Cell>
            );
    }
};

const PriceCell = ({rowData, dataKey, ...props}) => {
    return (
        <Cell {...props}>
            {rowData[dataKey].toLocaleString('es-ar', {
            style: 'currency',
            currency: 'ARS',
            minimumFractionDigits: 0
        })}
        </Cell>
    );
};

function TablaEmisionesOtros() {
    const classes = useStyles();

    //GET
    const [getEmisionesData, {data: emisionesData}] = useLazyQuery(GET_EMISIONES, {
        fetchPolicy: 'network-only',
    });

    //DIALOG
    const [filteredEmisiones, setFilteredEmisiones] = useState(null);
    const [rows, setRows] = useState(null);

    //PAGINATION
    const [page, setPage] = useState(1);
    const [displayLength, setDisplayLength] = useState(10);

    //SEARCH
    const handleSearchValueChange = (event) => {
        if (event.target.value.length >= 3) {
            let filtered = rows.filter((item) =>
                item["emision_clientes"][0]["Cliente"]["apellido"].toUpperCase().includes(event.target.value.toUpperCase())
                || item["NumeroReferencia"].toUpperCase().includes(event.target.value.toUpperCase())
                || item["emision_clientes"][0]["Cliente"]["nombre"].toUpperCase().includes(event.target.value.toUpperCase())
                || item["AfinidadInfo"][0]["Nombre"].toUpperCase().includes(event.target.value.toUpperCase())
                || item["emision_clientes"][0]["Cliente"]["dni"].toUpperCase().includes(event.target.value.toUpperCase())
            );
            setFilteredEmisiones(filtered);
        } else setFilteredEmisiones(null)
    };

    const getData = () => {
        return rows.filter((v, i) => {
            const start = displayLength * (page - 1);
            const end = start + displayLength;
            return i >= start && i < end;
        });
    };

    useEffect(() => {
        if (emisionesData === undefined) {
            getEmisionesData()
        } else if (emisionesData) {
            if (filteredEmisiones === null)
                setRows(emisionesData["Otros_Emisiones"]);
            else
                setRows(filteredEmisiones);
        }
    }, [filteredEmisiones, emisionesData]);

    if (!rows) return (<Loading/>);
    return (
        <Fragment>
            <div className={classes.table}>
                <div className={classes.endHorizontally} style={{marginRight: "48px", padding: "8px 0px"}}>
                    <div className={classes.centerVertically} style={{marginRight: "8px"}}><SearchIcon
                        style={{color: "#BB0D66"}}/></div>
                    <div className={classes.centerVertically} style={{marginTop: "-24px"}}>
                        <TextField
                            label="Buscar"
                            className={classes.alertField}
                            onChange={(e) => handleSearchValueChange(e)}/>
                    </div>
                </div>
                <Table
                    height={400}
                    width={980}
                    data={getData()}
                >
                    <Column fixed width={50} align="center">
                        <HeaderCell>ID</HeaderCell>
                        <Cell dataKey="idEmision"/>
                    </Column>
                    <Column width={100}>
                        <HeaderCell>Estado</HeaderCell>
                        <Cell dataKey="Estado"/>
                    </Column>
                    <Column width={120}>
                        <HeaderCell>Afinidad</HeaderCell>
                        <NameCell dataKey="AfinidadNombre"/>
                    </Column>
                    <Column width={180}>
                        <HeaderCell>Producto</HeaderCell>
                        <NameCell dataKey="ProductoInfo"/>
                    </Column>
                    <Column width={120}>
                        <HeaderCell>N° de referencia</HeaderCell>
                        <Cell dataKey="NumeroReferencia"/>
                    </Column>
                    <Column width={110}>
                        <HeaderCell>Cuota Mensual</HeaderCell>
                        <PriceCell dataKey="Premium"/>
                    </Column>
                    <Column width={100}>
                        <HeaderCell>DNI</HeaderCell>
                        <NameCell dataKey="DNI"/>
                    </Column>
                    <Column width={180}>
                        <HeaderCell>Nombre</HeaderCell>
                        <NameCell dataKey="ClienteNombre"/>
                    </Column>
                </Table>
                <div style={{padding: 20}}>
                    <Pagination
                        lengthMenu={[
                            {
                                value: 10,
                                label: 10
                            },
                            {
                                value: 20,
                                label: 20
                            }
                        ]}
                        activePage={page}
                        displayLength={displayLength}
                        total={rows.length}
                        onChangePage={(dataKey) => setPage(dataKey)}
                        onChangeLength={(dataKey) => setDisplayLength(dataKey)}
                    />
                </div>
            </div>
        </Fragment>
    )
}

export default withRoot(TablaEmisionesOtros);
